import { useLocation } from 'react-router-dom';

export type SingAlongBasePath = 'sing-along' | 'can-you-sing';

export function useSingAlongBasePath(): SingAlongBasePath {
  const { pathname } = useLocation();
  return pathname.startsWith('/can-you-sing') ? 'can-you-sing' : 'sing-along';
}
